import { View403 } from './403-view';
import { View500 } from './500-view';
import { hasStatus } from '../../lib/errors';
import { NotFoundView } from './not-found-view';

type Props = {
  error: unknown;
  fallback?: React.ComponentType;
};

export function ErrorView({ error, fallback: Fallback = NotFoundView }: Props) {
  if (hasStatus(error, 403)) {
    return <View403 />;
  }

  if (hasStatus(error, 500)) {
    return <View500 />;
  }

  return <Fallback />;
}
